export const brandLogoIsInUse = {
  type: "boolean"
};
